import { Box, Tooltip, styled } from '@mui/material'
import { ReactNode } from 'react'

export interface Props {
  count: number
  hint?: NonNullable<ReactNode>
}

const StyledBox = styled(Box)(({ theme }) => ({
  borderColor: theme.palette.neutralLight[500],
  color: theme.palette.neutralLight[0],
  backgroundColor: theme.palette.neutralLight[900],
  height: theme.spacing(4),
  padding: '0 6px',
  lineHeight: '16px',
  fontSize: 10,
  borderRadius: theme.spacing(1),
  width: 'fit-content',
}))

export function CounterChip({ count, hint = '' }: Props) {
  if (count === 0) {
    return null
  }
  return (
    <Tooltip title={hint} hidden={hint === ''}>
      <StyledBox>+{count}</StyledBox>
    </Tooltip>
  )
}
